module.exports = __webpack_public_path__ + "img/logo-footer.539f5cb2.svg";